<div style="overflow-y:auto; height: 100%; padding-right: 24px; overflow-x:hidden;">
  <div nz-row nzGutter="12">
    <nz-divider nzText="Hợp đồng" nzOrientation="left" nzPlain ></nz-divider>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Số hợp đồng</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Cơ quan tuyển dụng	</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Ngày bắt đầu</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Ngày kết thúc</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Ngày trở lại CT</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Nghề nghiệp khi được TD</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Nghỉ KL từ ngày</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maHS">Nghỉ KL đến ngày</nz-form-label>
        <nz-form-control nzSpan="24">
          <input nz-input name="email" type="email" id="email">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="8">
      <nz-form-item>
        <label nz-checkbox>Nghỉ không lương</label>
      </nz-form-item>
    </div>
  </div>
  <div>
    <nz-divider nzText="Diễn biến hợp đồng" nzOrientation="left" nzPlain ></nz-divider>
    <nz-table #basicTable [nzData]="listOfData" class="w-full" [nzScroll]="{x: '1500px'}">
      <thead>
        <tr>
          <th>STT</th>
          <th>Số Hợp đồng</th>
          <th>Loại hợp đồng</th>
          <th>HĐ có thời hạn từ ngày</th>
          <th>HĐ có thời hạn đến ngày</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data; let i = index;">
          <td>{{ i+1 }}</td>
          <td>{{ data.shd }}</td>
          <td>{{ data.lhd }}</td>
          <td>{{ data.bthd }}</td>
          <td>{{ data.kthd }}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>